export default {
  sex: {
    male: 'Мужчина',
    female: 'Женщина',
    other: 'Другое',
    unknown: 'Неизвестно',
  },
}
